import { render, staticRenderFns } from "./OccupationAreaAlterModal.vue?vue&type=template&id=39328ae9"
import script from "./OccupationAreaAlterModal.vue?vue&type=script&lang=js"
export * from "./OccupationAreaAlterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports